import { Box, Heading, Text } from '@chakra-ui/react'

import { IExperienceFeedbackSummary } from '../../../services/ExperienceFeedback/interfaces'

// Shared by the panel modal and the public completion screen so both match the PDF.
export default function ExperienceFeedbackScore({ score, max_score: maxScore, result }: IExperienceFeedbackSummary) {
  return (
    <Box mb="4">
      <Heading as="h3" mb="4">
        Resultado
      </Heading>

      <Box bg="magenta.500" color="white" textAlign="center" fontSize="2xl" fontWeight="bold" py="5" mb="4">
        {score} de {maxScore} pontos
      </Box>

      <Text whiteSpace="pre-line">{result?.message}</Text>
    </Box>
  )
}
